var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 103,
    viewBox: "0 0 282 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.5 87.8481C188.697 93.6075 176.107 90.3329 166.374 80.5326C156.642 70.7323 153.459 58.115 159.262 52.3556C165.066 46.5961 177.656 49.8707 187.388 59.671C197.117 69.4713 200.304 82.0886 194.5 87.8481Z",
    fill: "url(#paint0_linear_502_5693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.218 88.1294C188.415 93.8889 175.825 90.6142 166.092 80.814C156.363 71.0137 153.177 58.3964 158.98 52.6369C164.784 46.8774 177.374 50.1521 187.106 59.9524C196.839 69.7527 200.022 82.3699 194.218 88.1294Z",
    fill: "url(#paint1_linear_502_5693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.076 88.2718C188.195 94.1092 175.54 90.899 165.811 81.0953C156.082 71.295 152.96 58.6167 158.841 52.7793C164.723 46.9418 177.377 50.1521 187.11 59.9557C196.842 69.756 199.961 82.4343 194.08 88.2752L194.076 88.2718Z",
    fill: "url(#paint2_linear_502_5693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.792 88.5531C187.91 94.3906 175.256 91.1803 165.523 81.3766C155.791 71.5764 152.672 58.8981 158.554 53.0572C164.435 47.2198 177.09 50.43 186.819 60.2337C196.548 70.034 199.67 82.7123 193.788 88.5531H193.792Z",
    fill: "url(#paint3_linear_502_5693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.507 88.8345C187.626 94.672 174.971 91.4617 165.239 81.658C155.509 71.8578 152.387 59.1795 158.269 53.3386C164.15 47.5012 176.805 50.7114 186.537 60.5151C196.267 70.3154 199.389 82.9937 193.507 88.8345Z",
    fill: "url(#paint4_linear_502_5693)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 89.1158C187.344 94.9533 174.69 91.743 164.957 81.9394C155.228 72.1391 152.106 59.4608 157.987 53.6233C163.869 47.7859 176.523 50.9961 186.256 60.7998C195.988 70.6001 199.107 83.2784 193.229 89.1192L193.226 89.1158Z",
    fill: "url(#paint5_linear_502_5693)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.941 89.4005C187.059 95.238 174.404 92.0277 164.672 82.224C154.939 72.4238 151.821 59.7455 157.702 53.9046C163.584 48.0672 176.238 51.2774 185.967 61.0811C195.7 70.8814 198.819 83.5597 192.937 89.4005H192.941Z",
    fill: "url(#paint6_linear_502_5693)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.656 89.682C186.774 95.5194 174.12 92.3091 164.387 82.5055C154.658 72.7052 151.536 60.0269 157.418 54.1894C163.299 48.352 175.954 51.5623 185.686 61.3659C195.415 71.1662 198.537 83.8445 192.656 89.6853V89.682Z",
    fill: "url(#paint7_linear_502_5693)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.371 89.9633C186.49 95.8008 173.835 92.5905 164.103 82.7869C154.37 72.9866 151.251 60.3083 157.133 54.4674C163.014 48.63 175.669 51.8403 185.401 61.6439C195.131 71.4442 198.253 84.1225 192.371 89.9633Z",
    fill: "url(#paint8_linear_502_5693)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.087 90.2447C186.205 96.0822 173.551 92.8719 163.818 83.0682C154.086 73.268 150.967 60.5897 156.849 54.7488C162.73 48.9114 175.385 52.1216 185.114 61.9253C194.846 71.7256 197.965 84.4039 192.084 90.2447H192.087Z",
    fill: "url(#paint9_linear_502_5693)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.805 90.5261C185.923 96.3635 173.269 93.1533 163.536 83.3496C153.807 73.5493 150.685 60.871 156.567 55.0302C162.448 49.1927 175.103 52.403 184.835 62.2067C194.564 72.0069 197.686 84.6852 191.805 90.5227V90.5261Z",
    fill: "url(#paint10_linear_502_5693)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.79 87.5774C200.592 81.8174 197.408 69.2021 187.678 59.4004C177.948 49.5986 165.356 46.3221 159.554 52.0821C153.751 57.8422 156.935 70.4575 166.666 80.2592C176.396 90.061 188.987 93.3374 194.79 87.5774Z",
    fill: "#0C0232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.405 85.17C187.388 90.1532 176.496 87.3192 168.079 78.841C159.662 70.3662 156.91 59.454 161.927 54.4708C166.944 49.4877 177.835 52.3216 186.253 60.7998C194.67 69.278 197.422 80.1868 192.405 85.17Z",
    fill: "#040404"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.405 85.17C187.388 90.1532 176.496 87.3192 168.079 78.841C159.662 70.3662 156.91 59.454 161.927 54.4708C166.944 49.4877 177.835 52.3216 186.253 60.7998C194.67 69.278 197.422 80.1868 192.405 85.17Z",
    fill: "url(#paint11_linear_502_5693)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.31 87.0887C188.666 92.6922 176.415 89.5057 166.947 79.9699C157.479 70.434 154.381 58.1591 160.025 52.5555C165.669 46.952 177.92 50.1385 187.388 59.6744C196.856 69.2102 199.955 81.4851 194.31 87.0887ZM168.083 78.841C176.5 87.3192 187.388 90.1498 192.409 85.17C197.426 80.1868 194.673 69.278 186.256 60.7998C177.839 52.3216 166.95 49.491 161.93 54.4708C156.913 59.454 159.665 70.3628 168.083 78.841Z",
    fill: "url(#paint12_linear_502_5693)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.995 73.4867L179.566 78.6917C179.558 78.7069 179.551 78.722 179.54 78.7294C179.528 78.7398 179.517 78.7471 179.503 78.752C179.488 78.7546 179.476 78.7565 179.463 78.753C179.451 78.7494 179.438 78.7459 179.426 78.7339L175.924 75.9453C175.924 75.9453 175.902 75.9238 175.894 75.9111C175.886 75.8985 175.881 75.8798 175.877 75.8666C175.872 75.8479 175.873 75.831 175.874 75.814C175.876 75.7971 175.881 75.7796 175.888 75.7644L177.214 72.9208C177.246 72.8571 177.258 72.7827 177.258 72.7048C177.255 72.6299 177.235 72.5552 177.203 72.4908L173.392 65.3604C173.358 65.2991 173.339 65.2213 173.337 65.1464C173.335 65.0715 173.351 64.9964 173.38 64.9304L175.816 59.7132C175.831 59.6829 175.852 59.6628 175.877 59.6559C175.903 59.646 175.93 59.6501 175.953 59.6686L179.455 62.4572C179.455 62.4572 179.477 62.4788 179.485 62.4914C179.493 62.504 179.498 62.5227 179.505 62.5384C179.507 62.5546 179.509 62.574 179.507 62.5909C179.506 62.6078 179.501 62.6254 179.493 62.6405L178.161 65.4962C178.129 65.5599 178.116 65.6374 178.118 65.7123C178.119 65.7902 178.139 65.8649 178.173 65.9263L181.984 73.0567C182.016 73.121 182.037 73.1958 182.039 73.2707C182.041 73.3456 182.025 73.4206 181.995 73.4867Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.333 64.1027L180.217 66.4884C180.196 66.5308 180.19 66.5792 180.19 66.6294C180.19 66.6795 180.206 66.7271 180.225 66.7687L182.747 71.5057C182.756 71.5237 182.771 71.5381 182.784 71.547C182.8 71.5584 182.817 71.5613 182.833 71.5642C182.851 71.564 182.866 71.5561 182.881 71.5481C182.897 71.5371 182.908 71.5213 182.918 71.5031L185.008 67.0276C185.008 67.0276 185.019 66.9979 185.022 66.9779C185.023 66.961 185.025 66.9441 185.02 66.9254C185.017 66.9091 185.01 66.8935 185.002 66.8808C184.994 66.8682 184.984 66.8532 184.973 66.8466L181.473 64.0604C181.473 64.0604 181.448 64.0449 181.435 64.0414C181.423 64.0379 181.409 64.0374 181.395 64.0423C181.382 64.0473 181.371 64.0546 181.359 64.065C181.347 64.0754 181.34 64.0875 181.333 64.1027Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 74.2994L175.166 71.9136C175.187 71.8712 175.194 71.8228 175.191 71.7703C175.191 71.7201 175.175 71.6725 175.156 71.631L172.631 66.9C172.622 66.882 172.607 66.8676 172.592 66.8617C172.576 66.8503 172.56 66.8474 172.544 66.85C172.526 66.8501 172.511 66.8581 172.497 66.8661C172.48 66.8771 172.469 66.8929 172.46 66.9111L170.374 71.3775C170.374 71.3775 170.36 71.4048 170.36 71.4271C170.359 71.444 170.357 71.461 170.362 71.4796C170.365 71.4959 170.372 71.5116 170.378 71.5272C170.386 71.5399 170.397 71.5549 170.408 71.5614L173.91 74.35C173.933 74.3686 173.962 74.375 173.987 74.3681C174.014 74.3582 174.037 74.3405 174.05 74.3078L174.051 74.2994Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.996 73.4869L179.566 78.6919C179.558 78.7071 179.551 78.7222 179.54 78.7296C179.528 78.7399 179.517 78.7473 179.503 78.7522C179.488 78.7548 179.476 78.7567 179.463 78.7532C179.451 78.7496 179.438 78.7461 179.426 78.7341L175.924 75.9455C175.924 75.9455 175.902 75.924 175.894 75.9113C175.886 75.8987 175.881 75.88 175.877 75.8668C175.872 75.8481 175.873 75.8312 175.874 75.8142C175.876 75.7973 175.881 75.7798 175.888 75.7646L177.214 72.921C177.246 72.8573 177.258 72.7829 177.258 72.705C177.255 72.6301 177.235 72.5554 177.203 72.491L173.392 65.3606C173.358 65.2992 173.339 65.2215 173.337 65.1466C173.335 65.0717 173.351 64.9966 173.38 64.9305L175.816 59.7134C175.831 59.6831 175.852 59.663 175.877 59.6561C175.903 59.6462 175.93 59.6503 175.953 59.6688L179.456 62.4574C179.456 62.4574 179.477 62.479 179.485 62.4916C179.493 62.5042 179.498 62.5229 179.505 62.5385C179.507 62.5548 179.509 62.5741 179.507 62.5911C179.506 62.608 179.501 62.6256 179.493 62.6407L178.161 65.4964C178.129 65.5601 178.116 65.6375 178.118 65.7124C178.119 65.7904 178.139 65.8651 178.173 65.9265L181.984 73.0569C182.016 73.1212 182.037 73.196 182.039 73.2709C182.041 73.3458 182.025 73.4208 181.996 73.4869Z",
    fill: "url(#paint13_linear_502_5693)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.333 64.1029L180.217 66.4886C180.196 66.5311 180.19 66.5794 180.19 66.6296C180.19 66.6797 180.206 66.7273 180.225 66.7689L182.747 71.5059C182.756 71.5239 182.771 71.5383 182.784 71.5473C182.8 71.5586 182.817 71.5615 182.833 71.5644C182.851 71.5642 182.866 71.5563 182.881 71.5483C182.897 71.5373 182.908 71.5215 182.918 71.5033L185.008 67.0278C185.008 67.0278 185.019 66.9981 185.022 66.9781C185.023 66.9612 185.025 66.9443 185.02 66.9256C185.017 66.9093 185.01 66.8937 185.002 66.881C184.994 66.8684 184.984 66.8534 184.973 66.8468L181.473 64.0607C181.473 64.0607 181.448 64.0451 181.435 64.0416C181.423 64.0381 181.409 64.0376 181.395 64.0426C181.382 64.0475 181.371 64.0548 181.359 64.0652C181.347 64.0756 181.34 64.0877 181.333 64.1029Z",
    fill: "url(#paint14_linear_502_5693)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.05 74.2994L175.166 71.9137C175.187 71.8712 175.193 71.8228 175.191 71.7703C175.191 71.7202 175.175 71.6726 175.156 71.631L172.63 66.9001C172.621 66.882 172.607 66.8676 172.592 66.8617C172.576 66.8504 172.56 66.8475 172.544 66.85C172.526 66.8502 172.511 66.8582 172.496 66.8661C172.48 66.8771 172.469 66.8929 172.46 66.9111L170.374 71.3775C170.374 71.3775 170.36 71.4048 170.36 71.4272C170.358 71.4441 170.357 71.461 170.362 71.4797C170.365 71.496 170.371 71.5116 170.378 71.5273C170.386 71.5399 170.396 71.5549 170.407 71.5615L173.91 74.3501C173.933 74.3686 173.962 74.375 173.987 74.3682C174.014 74.3583 174.037 74.3406 174.05 74.3079L174.05 74.2994Z",
    fill: "url(#paint15_linear_502_5693)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.485 -13.0051C180.167 -1.71667 170.122 16.5855 151.054 27.874C131.982 39.1624 111.107 39.159 104.426 27.8706C97.7441 16.5821 107.785 -1.72006 126.857 -13.0085C145.928 -24.297 166.804 -24.2936 173.485 -13.0051Z",
    fill: "url(#paint16_linear_502_5693)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.81 -12.4525C180.492 -1.16406 170.451 17.1381 151.379 28.4266C132.307 39.715 111.432 39.7117 104.75 28.4232C98.0689 17.1348 108.113 -1.16745 127.182 -12.4559C146.253 -23.7443 167.128 -23.7409 173.81 -12.4525Z",
    fill: "url(#paint17_linear_502_5693)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M173.974 -12.1745C180.747 -0.733532 170.777 17.6941 151.706 28.9825C132.634 40.271 111.684 40.1422 104.911 28.7012C98.138 17.2602 108.108 -1.16744 127.18 -12.4559C146.251 -23.7443 167.201 -23.6189 173.974 -12.1745Z",
    fill: "url(#paint18_linear_502_5693)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174.302 -11.622C181.075 -0.180996 171.105 18.2466 152.034 29.5351C132.962 40.8235 112.012 40.6981 105.239 29.2537C98.4662 17.8093 108.436 -0.614906 127.508 -11.9034C146.579 -23.1918 167.529 -23.0664 174.299 -11.622H174.302Z",
    fill: "url(#paint19_linear_502_5693)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.628 -11.0694C181.401 0.371578 171.431 18.7992 152.359 30.0876C133.288 41.3761 112.338 41.2507 105.568 29.8063C98.7953 18.3619 108.765 -0.0623322 127.837 -11.3508C146.908 -22.6392 167.858 -22.5138 174.631 -11.0694H174.628Z",
    fill: "url(#paint20_linear_502_5693)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.956 -10.5168C181.729 0.924152 171.76 19.3518 152.688 30.6402C133.616 41.9287 112.666 41.8032 105.893 30.3589C99.1202 18.9179 109.09 0.490242 128.162 -10.7982C147.233 -22.0866 168.183 -21.9612 174.956 -10.5168Z",
    fill: "url(#paint21_linear_502_5693)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.282 -9.96432C182.055 1.47667 172.085 19.9043 153.013 31.1927C133.942 42.4812 112.992 42.3558 106.219 30.9114C99.4457 19.4704 109.415 1.04276 128.487 -10.2457C147.559 -21.5341 168.509 -21.4087 175.282 -9.96432Z",
    fill: "url(#paint22_linear_502_5693)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.611 -9.41183C182.384 2.02916 172.414 20.4568 153.342 31.7452C134.271 43.0337 113.321 42.9049 106.548 31.4639C99.7748 20.0229 109.745 1.59525 128.816 -9.69319C147.888 -20.9816 168.838 -20.8562 175.611 -9.41183Z",
    fill: "url(#paint23_linear_502_5693)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M175.936 -8.85922C182.709 2.58178 172.739 21.0094 153.668 32.2978C134.596 43.5863 113.646 43.4609 106.873 32.0165C100.1 20.5721 110.07 2.14787 129.141 -9.14058C148.213 -20.429 169.163 -20.3036 175.933 -8.85922H175.936Z",
    fill: "url(#paint24_linear_502_5693)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.265 -8.3066C183.038 3.13439 173.068 21.562 153.997 32.8505C134.925 44.1389 113.975 44.0135 107.202 32.5691C100.429 21.1247 110.399 2.70048 129.471 -8.58797C148.542 -19.8764 169.492 -19.751 176.265 -8.3066Z",
    fill: "url(#paint25_linear_502_5693)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M176.59 -7.75408C183.364 3.68691 173.394 22.1145 154.322 33.403C135.25 44.6914 114.301 44.5626 107.528 33.1216C100.754 21.6806 110.724 3.253 129.796 -8.03545C148.868 -19.3239 169.817 -19.1985 176.59 -7.75408Z",
    fill: "url(#paint26_linear_502_5693)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.726 27.3205C169.798 16.0328 179.841 -2.26944 173.159 -13.5588C166.478 -24.8481 145.601 -24.8495 126.529 -13.5618C107.458 -2.27415 97.4147 16.0281 104.097 27.3175C110.778 38.6068 131.655 38.6081 150.726 27.3205Z",
    fill: "#0C0232"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M168.491 -10.7948C174.271 -1.03187 165.582 14.7991 149.09 24.5587C132.598 34.3216 114.54 34.3183 108.761 24.5553C102.981 14.7923 111.669 -1.03865 128.161 -10.7982C144.653 -20.5612 162.711 -20.5578 168.491 -10.7948Z",
    fill: "#0C0232"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M168.491 -10.7948C174.271 -1.03187 165.582 14.7991 149.09 24.5587C132.598 34.3216 114.54 34.3183 108.761 24.5553C102.981 14.7923 111.669 -1.03865 128.161 -10.7982C144.653 -20.5612 162.711 -20.5578 168.491 -10.7948Z",
    fill: "url(#paint27_linear_502_5693)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.224 -13.0051C178.726 -2.02173 168.953 15.7889 150.4 26.7689C131.843 37.7522 111.531 37.7489 105.029 26.7655C98.5271 15.7821 108.3 -2.02851 126.853 -13.0085C145.41 -23.9918 165.722 -23.9884 172.224 -13.0051ZM149.091 24.5587C165.583 14.7957 174.272 -1.03187 168.492 -10.7982C162.712 -20.5612 144.657 -20.5646 128.165 -10.8016C111.673 -1.03865 102.985 14.7889 108.765 24.5519C114.545 34.3149 132.599 34.3183 149.091 24.5553V24.5587Z",
    fill: "url(#paint28_linear_502_5693)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M147.386 8.29029L139.822 2.39887C139.686 2.2914 139.672 2.09289 139.786 1.88618L142.23 -2.47911C142.282 -2.57328 142.25 -2.66057 142.158 -2.67367L135.332 -3.54341C135.24 -3.55651 135.118 -3.48675 135.066 -3.39258L130.573 4.62464C130.456 4.8304 130.473 5.02986 130.609 5.13733L138.173 11.0288C138.309 11.1362 138.323 11.3347 138.209 11.5414L135.765 15.9067C135.713 16.0009 135.745 16.0882 135.837 16.1013L142.663 16.971C142.755 16.9841 142.877 16.9144 142.929 16.8202L147.423 8.80298C147.539 8.59723 147.522 8.39776 147.386 8.29029Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.9 -1.30436L146.075 -2.1741C145.983 -2.1872 145.86 -2.11743 145.808 -2.02327L143.755 1.64156C143.679 1.77798 143.689 1.91171 143.779 1.98443L148.795 5.89124C148.878 5.95463 149.052 5.88963 149.121 5.76515L152.972 -1.10657C153.024 -1.20074 152.991 -1.28803 152.899 -1.30113L152.9 -1.30436Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.209 11.4456L129.193 7.53881C129.111 7.47542 128.936 7.54042 128.867 7.6649L125.017 14.5366C124.965 14.6308 124.997 14.7181 125.089 14.7312L131.915 15.6009C132.007 15.614 132.129 15.5443 132.181 15.4501L134.234 11.7853C134.311 11.6488 134.301 11.5151 134.21 11.4424L134.209 11.4456Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.385 8.29049L139.821 2.39906C139.685 2.29159 139.671 2.09309 139.785 1.88637L142.229 -2.47891C142.281 -2.57308 142.249 -2.66038 142.157 -2.67348L135.331 -3.54322C135.239 -3.55632 135.117 -3.48655 135.065 -3.39239L130.571 4.62484C130.455 4.83059 130.472 5.03006 130.608 5.13753L138.172 11.0289C138.308 11.1364 138.322 11.3349 138.208 11.5416L135.764 15.9069C135.712 16.0011 135.744 16.0884 135.836 16.1015L142.662 16.9712C142.754 16.9843 142.876 16.9146 142.928 16.8204L147.422 8.80318C147.538 8.59742 147.521 8.39795 147.385 8.29049Z",
    fill: "url(#paint29_linear_502_5693)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.901 -1.30423L146.075 -2.17397C145.983 -2.18707 145.86 -2.11731 145.808 -2.02314L143.755 1.64169C143.679 1.77811 143.689 1.91184 143.779 1.98456L148.795 5.89137C148.878 5.95475 149.052 5.88976 149.121 5.76528L152.972 -1.10644C153.024 -1.20061 152.991 -1.28791 152.9 -1.30101L152.901 -1.30423Z",
    fill: "url(#paint30_linear_502_5693)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.209 11.4457L129.193 7.53891C129.111 7.47553 128.936 7.54052 128.867 7.665L125.017 14.5367C124.965 14.6309 124.997 14.7182 125.089 14.7313L131.915 15.601C132.007 15.6141 132.129 15.5444 132.181 15.4502L134.235 11.7854C134.311 11.6489 134.301 11.5152 134.211 11.4425L134.209 11.4457Z",
    fill: "url(#paint31_linear_502_5693)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0127 76.9897C77.3481 91.5358 49.5914 90.0917 25.0178 73.7659C0.444252 57.44 -11.6374 32.4088 -1.97276 17.8626C7.69191 3.31648 35.4486 4.76058 60.0222 21.0864C84.5957 37.4123 96.6774 62.4435 87.0127 76.9897Z",
    fill: "url(#paint32_linear_502_5693)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5367 77.7016C76.872 92.2478 49.1153 90.807 24.5418 74.4778C-0.0283728 58.1519 -12.1134 33.1207 -2.44878 18.5745C7.2159 4.02838 34.9726 5.4725 59.5462 21.7984C84.1197 38.1276 96.2014 63.1554 86.5367 77.7016Z",
    fill: "url(#paint33_linear_502_5693)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3027 78.0576C76.5058 92.8004 48.644 91.519 24.0705 75.1897C-0.503084 58.8638 -12.4797 33.6733 -2.6828 18.9305C7.11407 4.18777 34.9759 5.47255 59.5494 21.7984C84.123 38.1277 96.0996 63.3148 86.3027 78.0576Z",
    fill: "url(#paint34_linear_502_5693)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8286 78.7695C76.0317 93.5123 48.17 92.2275 23.5964 75.9016C-0.973762 59.5758 -12.9538 34.3852 -3.15687 19.6425C6.64001 4.89968 34.5018 6.18446 59.0753 22.5103C83.6489 38.8396 95.6255 64.0267 85.8286 78.7695Z",
    fill: "url(#paint35_linear_502_5693)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3564 79.4813C75.5595 94.2241 47.6977 92.9427 23.1242 76.6134C-1.44937 60.2875 -13.426 35.097 -3.62909 20.3542C6.16779 5.61147 34.0296 6.89626 58.6031 23.2221C83.1767 39.5514 95.1533 64.7385 85.3564 79.4813Z",
    fill: "url(#paint36_linear_502_5693)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8833 80.1932C75.0864 94.936 47.2246 93.6546 22.6511 77.3253C-1.91907 60.9995 -13.8991 35.8089 -4.10219 21.0662C5.69469 6.32339 33.5565 7.60818 58.13 23.934C82.7036 40.2633 94.6802 65.4504 84.8833 80.1932Z",
    fill: "url(#paint37_linear_502_5693)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4111 80.905C74.6142 95.6478 46.7524 94.3664 22.1789 78.0371C-2.39469 61.7113 -14.3713 36.5207 -4.57441 21.778C5.22247 7.03518 33.0843 8.31996 57.6578 24.6458C82.2314 40.9717 94.208 66.1622 84.4111 80.905Z",
    fill: "url(#paint38_linear_502_5693)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M83.937 81.6169C74.1401 96.3597 46.2784 95.0783 21.7048 78.749C-2.86536 62.4232 -14.8454 37.2327 -5.04847 22.4899C4.7484 7.7471 32.6102 9.03188 57.1837 25.3577C81.7573 41.687 93.7339 66.8741 83.937 81.6169Z",
    fill: "url(#paint39_linear_502_5693)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M83.462 82.3288C73.6651 97.0716 45.8033 95.7868 21.2298 79.461C-3.3404 63.1351 -15.317 37.9446 -5.52351 23.2018C4.27337 8.45901 32.1352 9.74379 56.7087 26.0697C81.2823 42.3989 93.2589 67.5861 83.462 82.3288Z",
    fill: "url(#paint40_linear_502_5693)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9917 83.0407C73.1948 97.7835 45.333 96.5021 20.7595 80.1729C-3.81068 63.847 -15.7907 38.6565 -5.99379 23.9137C3.80309 9.17092 31.6649 10.4557 56.2384 26.7816C80.812 43.1108 92.7886 68.298 82.9917 83.0407Z",
    fill: "url(#paint41_linear_502_5693)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5171 83.7526C72.7202 98.4954 44.8584 97.214 20.2849 80.8848C-4.28529 64.5589 -16.2653 39.3684 -6.4684 24.6256C3.32848 9.88284 31.1903 11.1676 55.7638 27.4935C80.3374 43.8228 92.314 69.0099 82.5171 83.7526Z",
    fill: "url(#paint42_linear_502_5693)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4874 76.2676C97.1529 61.72 85.0679 36.6917 60.4949 20.3655C35.9219 4.03924 8.1662 2.59737 -1.49921 17.145C-11.1646 31.6926 0.920341 56.7208 25.4933 73.0471C50.0663 89.3733 77.822 90.8152 87.4874 76.2676Z",
    fill: "#0C0232"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4719 72.2845C73.1124 84.8645 49.1083 83.617 27.8569 69.4946C6.60544 55.3722 -3.84569 33.7275 4.51386 21.1441C12.8734 8.56413 36.8775 9.81163 58.1323 23.9341C79.3837 38.0565 89.8349 59.7011 81.4753 72.2845H81.4719Z",
    fill: "#0C0232"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4719 72.2845C73.1124 84.8645 49.1083 83.617 27.8569 69.4946C6.60544 55.3722 -3.84569 33.7275 4.51386 21.1441C12.8734 8.56413 36.8775 9.81163 58.1323 23.9341C79.3837 38.0565 89.8349 59.7011 81.4753 72.2845H81.4719Z",
    fill: "url(#paint43_linear_502_5693)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2838 75.4813C76.8802 89.6342 49.8727 88.2308 25.9635 72.3456C2.05442 56.457 -9.70184 32.1038 -0.298189 17.9509C9.10546 3.79795 36.113 5.20138 60.0221 21.0866C83.9312 36.9717 95.6875 61.325 86.2838 75.4779V75.4813ZM27.8551 69.4981C49.1066 83.6205 73.114 84.868 81.4735 72.288C89.8331 59.708 79.382 38.0599 58.1305 23.9375C36.8791 9.81507 12.8717 8.56758 4.51211 21.1476C-3.84744 33.7276 6.60369 55.3756 27.8551 69.4981Z",
    fill: "url(#paint44_linear_502_5693)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0631 36.312L42.9105 30.3888C42.8573 30.3502 42.7878 30.3316 42.7173 30.3371C42.6468 30.3427 42.5811 30.3719 42.5346 30.4184L34.3289 38.6241C34.2264 38.7265 34.1599 38.8513 34.1374 38.9835C34.1148 39.1158 34.1372 39.2498 34.2018 39.3696L41.6199 52.8672C41.6854 52.9861 41.7086 53.1196 41.6866 53.2515C41.6645 53.3833 41.5983 53.5077 41.496 53.6096L37.0222 58.0834C36.9981 58.1066 36.9797 58.1336 36.9679 58.1628C36.9562 58.192 36.9513 58.2227 36.9537 58.2532C36.9561 58.2837 36.9657 58.3134 36.9819 58.3403C36.9981 58.3673 37.0205 58.3911 37.0479 58.4102L45.2004 64.3334C45.227 64.3534 45.258 64.3685 45.2919 64.3779C45.3257 64.3872 45.3615 64.3906 45.3972 64.3878C45.4329 64.385 45.4678 64.376 45.4997 64.3615C45.5316 64.347 45.56 64.3272 45.5831 64.3033L53.77 56.1164C53.8725 56.014 53.939 55.8892 53.9615 55.7569C53.984 55.6247 53.9617 55.4907 53.897 55.3709L46.4789 41.8733C46.4137 41.7536 46.391 41.6194 46.4136 41.4871C46.4361 41.3547 46.503 41.2299 46.606 41.1277L51.0955 36.6383C51.1185 36.6145 51.1359 36.5872 51.1467 36.5579C51.1575 36.5286 51.1615 36.498 51.1585 36.4677C51.1555 36.4374 51.1455 36.4081 51.1291 36.3813C51.1127 36.3546 51.0903 36.3311 51.0631 36.312Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4233 39.7842L51.6465 43.5611C51.5816 43.6296 51.5401 43.7118 51.5266 43.7982C51.5131 43.8845 51.5282 43.9715 51.5702 44.049L56.405 52.9958C56.4232 53.0299 56.4513 53.0593 56.4867 53.0812C56.5221 53.1031 56.5636 53.1168 56.6075 53.1212C56.6514 53.1255 56.6963 53.1203 56.7381 53.1061C56.7799 53.0918 56.8172 53.069 56.8466 53.0396L63.9251 45.9611C63.9485 45.9377 63.9664 45.9107 63.9778 45.8816C63.9891 45.8526 63.9937 45.8221 63.9912 45.792C63.9888 45.7619 63.9793 45.7327 63.9634 45.7062C63.9474 45.6796 63.9254 45.6563 63.8985 45.6375L55.8024 39.7553C55.7764 39.7357 55.7458 39.7208 55.7126 39.7116C55.6793 39.7024 55.644 39.6991 55.6087 39.7018C55.5734 39.7044 55.5388 39.7131 55.507 39.7273C55.4752 39.7414 55.4467 39.7608 55.4233 39.7842Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6939 54.9372L36.4748 51.1562C36.5392 51.0874 36.5805 51.0052 36.5941 50.9189C36.6076 50.8326 36.5929 50.7456 36.5515 50.6679L31.7106 41.7272C31.6913 41.6936 31.6625 41.6648 31.6266 41.6435C31.5908 41.6222 31.5491 41.609 31.5051 41.605C31.4612 41.601 31.4163 41.6064 31.3746 41.6206C31.3328 41.6349 31.2954 41.6576 31.2656 41.6868L24.1922 48.7603C24.1683 48.7834 24.1498 48.8101 24.1378 48.839C24.1258 48.8679 24.1206 48.8984 24.1225 48.9286C24.1243 48.9588 24.1331 48.9881 24.1485 49.0149C24.1638 49.0417 24.1854 49.0654 24.2119 49.0847L32.3115 54.9694C32.3653 55.0085 32.4358 55.027 32.5075 55.021C32.5792 55.0149 32.6463 54.9848 32.6939 54.9372Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0635 36.3117L42.9109 30.3885C42.8577 30.3499 42.7883 30.3313 42.7178 30.3368C42.6473 30.3424 42.5815 30.3716 42.535 30.4181L34.3293 38.6238C34.2268 38.7262 34.1603 38.851 34.1378 38.9832C34.1153 39.1155 34.1376 39.2495 34.2023 39.3693L41.6204 52.8669C41.6858 52.9858 41.709 53.1193 41.687 53.2512C41.665 53.383 41.5988 53.5074 41.4964 53.6093L37.0226 58.0832C36.9985 58.1064 36.9801 58.1333 36.9683 58.1625C36.9566 58.1917 36.9518 58.2224 36.9542 58.2529C36.9566 58.2835 36.9661 58.3131 36.9823 58.34C36.9985 58.367 37.0209 58.3908 37.0483 58.4099L45.2009 64.3331C45.2274 64.3531 45.2585 64.3683 45.2923 64.3776C45.3261 64.3869 45.3619 64.3903 45.3976 64.3875C45.4333 64.3847 45.4682 64.3757 45.5001 64.3612C45.5321 64.3467 45.5604 64.3269 45.5835 64.303L53.7704 56.1161C53.8729 56.0137 53.9394 55.8889 53.9619 55.7567C53.9845 55.6244 53.9621 55.4904 53.8975 55.3706L46.4794 41.873C46.4142 41.7533 46.3914 41.6192 46.414 41.4868C46.4366 41.3545 46.5034 41.2296 46.6064 41.1275L51.0959 36.638C51.1189 36.6142 51.1363 36.5869 51.1471 36.5576C51.1579 36.5284 51.1619 36.4977 51.1589 36.4674C51.1559 36.4371 51.1459 36.4078 51.1295 36.3811C51.1132 36.3543 51.0907 36.3308 51.0635 36.3117Z",
    fill: "url(#paint45_linear_502_5693)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4239 39.784L51.647 43.5609C51.5822 43.6295 51.5406 43.7116 51.5271 43.798C51.5136 43.8843 51.5287 43.9713 51.5707 44.0488L56.4055 52.9956C56.4238 53.0298 56.4519 53.0591 56.4873 53.081C56.5226 53.1029 56.5642 53.1167 56.6081 53.121C56.652 53.1254 56.6969 53.1202 56.7386 53.1059C56.7804 53.0916 56.8177 53.0688 56.8472 53.0394L63.9256 45.9609C63.9491 45.9375 63.967 45.9105 63.9783 45.8815C63.9897 45.8524 63.9943 45.822 63.9918 45.7918C63.9893 45.7617 63.9798 45.7325 63.9639 45.706C63.948 45.6794 63.9259 45.6561 63.8991 45.6373L55.803 39.7551C55.7769 39.7355 55.7464 39.7206 55.7131 39.7114C55.6799 39.7022 55.6446 39.6989 55.6093 39.7016C55.574 39.7043 55.5394 39.7129 55.5076 39.7271C55.4757 39.7412 55.4473 39.7606 55.4239 39.784Z",
    fill: "url(#paint46_linear_502_5693)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6948 54.937L36.4758 51.156C36.5402 51.0872 36.5815 51.005 36.595 50.9187C36.6086 50.8324 36.5938 50.7454 36.5524 50.6677L31.7116 41.727C31.6922 41.6934 31.6634 41.6646 31.6276 41.6433C31.5917 41.622 31.55 41.6088 31.5061 41.6048C31.4621 41.6008 31.4173 41.6062 31.3755 41.6204C31.3338 41.6347 31.2963 41.6574 31.2666 41.6866L24.1931 48.7601C24.1692 48.7832 24.1507 48.8099 24.1388 48.8388C24.1268 48.8677 24.1216 48.8982 24.1234 48.9284C24.1252 48.9586 24.1341 48.9879 24.1494 49.0147C24.1648 49.0415 24.1863 49.0652 24.2128 49.0845L32.3124 54.9692C32.3662 55.0083 32.4367 55.0268 32.5084 55.0208C32.5802 55.0147 32.6472 54.9846 32.6948 54.937Z",
    fill: "url(#paint47_linear_502_5693)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M263.971 65.8351C273.863 71.1742 274.572 89.0459 265.551 105.755C256.534 122.464 241.205 131.681 231.313 126.342C221.421 121.003 220.712 103.131 229.73 86.4221C238.747 69.7131 254.076 60.4959 263.968 65.8351H263.971Z",
    fill: "url(#paint48_linear_502_5693)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M264.456 66.096C274.348 71.4352 275.056 89.3068 266.036 106.016C257.018 122.725 241.689 131.942 231.797 126.603C221.906 121.264 221.197 103.392 230.214 86.683C239.231 69.9741 254.561 60.7569 264.452 66.096H264.456Z",
    fill: "url(#paint49_linear_502_5693)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M264.697 66.2248C274.721 71.6352 275.538 89.5679 266.521 106.277C257.504 122.986 242.066 132.145 232.039 126.735C222.015 121.325 221.198 103.392 230.215 86.683C239.232 69.9741 254.67 60.8145 264.697 66.2248Z",
    fill: "url(#paint50_linear_502_5693)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M265.181 66.4859C275.205 71.8962 276.022 89.8289 267.005 106.538C257.988 123.247 242.55 132.406 232.522 126.993C222.498 121.582 221.681 103.65 230.699 86.9407C239.716 70.2318 255.154 61.0722 265.181 66.4859Z",
    fill: "url(#paint51_linear_502_5693)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M265.665 66.7469C275.689 72.1572 276.506 90.0899 267.489 106.799C258.472 123.508 243.034 132.667 233.007 127.257C222.983 121.847 222.166 103.914 231.183 87.2051C240.2 70.4962 255.638 61.3366 265.665 66.7469Z",
    fill: "url(#paint52_linear_502_5693)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M266.148 67.0114C276.172 72.4218 276.988 90.3545 267.971 107.063C258.954 123.772 243.516 132.932 233.489 127.522C223.465 122.111 222.648 104.179 231.665 87.4696C240.682 70.7607 256.12 61.6011 266.148 67.0114Z",
    fill: "url(#paint53_linear_502_5693)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M266.632 67.2724C276.656 72.6828 277.473 90.6155 268.456 107.324C259.438 124.033 244.001 133.193 233.973 127.783C223.949 122.372 223.132 104.44 232.15 87.7306C241.167 71.0217 256.605 61.8621 266.632 67.2724Z",
    fill: "url(#paint54_linear_502_5693)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M267.117 67.5333C277.141 72.9437 277.958 90.8764 268.941 107.585C259.924 124.294 244.486 133.454 234.459 128.04C224.435 122.63 223.618 104.697 232.635 87.9881C241.652 71.2792 257.09 62.1196 267.117 67.5333Z",
    fill: "url(#paint55_linear_502_5693)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M267.602 67.7944C277.626 73.2048 278.443 91.1375 269.425 107.846C260.408 124.555 244.97 133.715 234.943 128.301C224.919 122.891 224.102 104.958 233.119 88.2492C242.137 71.5403 257.574 62.3807 267.602 67.791V67.7944Z",
    fill: "url(#paint56_linear_502_5693)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M268.086 68.0555C278.11 73.4658 278.927 91.3985 269.91 108.107C260.893 124.816 245.455 133.976 235.428 128.562C225.404 123.152 224.587 105.219 233.604 88.5103C242.621 71.8014 258.059 62.6418 268.086 68.0521V68.0555Z",
    fill: "url(#paint57_linear_502_5693)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M268.568 68.3165C278.592 73.7268 279.409 91.6595 270.392 108.368C261.375 125.077 245.937 134.237 235.91 128.823C225.886 123.413 225.069 105.48 234.086 88.7713C243.103 72.0624 258.541 62.9028 268.568 68.3165Z",
    fill: "url(#paint58_linear_502_5693)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M265.07 105.505C274.089 88.7963 273.382 70.9225 263.491 65.5831C253.599 60.2436 238.269 69.4604 229.249 86.1694C220.23 102.878 220.937 120.752 230.829 126.092C240.72 131.431 256.051 122.214 265.07 105.505Z",
    fill: "#0C0232"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M261.28 69.6623C269.836 74.2794 270.446 89.7375 262.646 104.189C254.846 118.64 241.588 126.61 233.035 121.993C224.479 117.376 223.869 101.917 231.665 87.4662C239.466 73.015 252.724 65.0453 261.276 69.6623H261.28Z",
    fill: "#0C0232"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M261.28 69.6623C269.836 74.2794 270.446 89.7375 262.646 104.189C254.846 118.64 241.588 126.61 233.035 121.993C224.479 117.376 223.869 101.917 231.665 87.4662C239.466 73.015 252.724 65.0453 261.276 69.6623H261.28Z",
    fill: "url(#paint59_linear_502_5693)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.046 66.391C272.67 71.5843 273.358 88.9746 264.585 105.233C255.811 121.491 240.896 130.457 231.272 125.264C221.648 120.07 220.96 102.68 229.733 86.422C238.509 70.164 253.422 61.1976 263.046 66.391ZM262.649 104.189C270.449 89.7374 269.836 74.2793 261.283 69.6623C252.727 65.0452 239.469 73.0149 231.672 87.4661C223.872 101.917 224.485 117.375 233.038 121.993C241.594 126.61 254.852 118.64 262.652 104.189H262.649Z",
    fill: "url(#paint60_linear_502_5693)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M249.783 88.6438L245.398 84.2588C245.369 84.2302 245.333 84.2164 245.298 84.2205C245.263 84.2246 245.231 84.2462 245.21 84.2807L241.453 90.3539C241.406 90.4297 241.378 90.5221 241.373 90.62C241.368 90.7179 241.385 90.8171 241.423 90.9058L245.789 100.897C245.828 100.985 245.846 101.084 245.841 101.182C245.836 101.279 245.808 101.371 245.761 101.447L243.713 104.758C243.702 104.775 243.694 104.795 243.689 104.817C243.685 104.838 243.684 104.861 243.686 104.884C243.689 104.906 243.695 104.928 243.705 104.948C243.714 104.968 243.726 104.986 243.741 105L248.126 109.385C248.14 109.4 248.157 109.411 248.174 109.418C248.192 109.425 248.21 109.427 248.228 109.425C248.246 109.423 248.263 109.416 248.278 109.406C248.294 109.395 248.307 109.38 248.318 109.363L252.066 103.303C252.113 103.228 252.14 103.135 252.146 103.037C252.151 102.939 252.133 102.84 252.095 102.751L247.729 92.7599C247.691 92.6713 247.673 92.572 247.679 92.4741C247.684 92.3761 247.712 92.2837 247.759 92.2081L249.814 88.8853C249.825 88.8677 249.832 88.8475 249.836 88.8258C249.841 88.8042 249.841 88.7815 249.838 88.759C249.835 88.7366 249.829 88.7149 249.819 88.6951C249.81 88.6753 249.798 88.6579 249.783 88.6438Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M252.113 91.1837L250.393 93.9643C250.363 94.0148 250.347 94.0755 250.344 94.1393C250.342 94.2032 250.354 94.2676 250.379 94.3251L253.267 100.964C253.278 100.989 253.293 101.011 253.312 101.027C253.331 101.044 253.353 101.054 253.375 101.057C253.398 101.061 253.42 101.057 253.44 101.047C253.461 101.036 253.479 101.019 253.492 100.998L256.716 95.7864C256.726 95.7692 256.734 95.7493 256.738 95.7278C256.742 95.7064 256.743 95.6839 256.741 95.6616C256.738 95.6393 256.732 95.6176 256.722 95.5979C256.713 95.5782 256.701 95.5609 256.686 95.5469L252.303 91.1638C252.289 91.1492 252.273 91.1381 252.255 91.1311C252.238 91.1242 252.22 91.1216 252.202 91.1234C252.185 91.1253 252.168 91.1316 252.152 91.1419C252.137 91.1523 252.124 91.1665 252.113 91.1837Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M241.415 102.46L243.135 99.679C243.164 99.6283 243.18 99.5677 243.183 99.5039C243.185 99.4402 243.174 99.3758 243.149 99.3182L240.256 92.6866C240.245 92.6616 240.229 92.6402 240.21 92.6243C240.191 92.6084 240.169 92.5984 240.147 92.5953C240.124 92.5922 240.102 92.596 240.081 92.6064C240.061 92.6167 240.043 92.6334 240.03 92.6549L236.812 97.8569C236.801 97.8739 236.793 97.8936 236.788 97.9149C236.784 97.9362 236.783 97.9587 236.785 97.981C236.788 98.0034 236.793 98.0251 236.803 98.045C236.812 98.0649 236.824 98.0825 236.838 98.0968L241.223 102.482C241.252 102.511 241.289 102.525 241.325 102.521C241.361 102.517 241.393 102.495 241.415 102.46Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M249.783 88.6438L245.398 84.2588C245.369 84.2302 245.333 84.2164 245.298 84.2205C245.263 84.2246 245.231 84.2462 245.21 84.2807L241.453 90.3539C241.406 90.4297 241.378 90.5221 241.373 90.62C241.368 90.7179 241.385 90.8171 241.423 90.9058L245.789 100.897C245.828 100.985 245.846 101.084 245.841 101.182C245.836 101.279 245.808 101.371 245.761 101.447L243.713 104.758C243.702 104.775 243.694 104.795 243.689 104.817C243.685 104.838 243.684 104.861 243.686 104.884C243.689 104.906 243.695 104.928 243.705 104.948C243.714 104.968 243.726 104.986 243.741 105L248.126 109.385C248.14 109.4 248.157 109.411 248.174 109.418C248.192 109.425 248.21 109.427 248.228 109.425C248.246 109.423 248.263 109.416 248.278 109.406C248.294 109.395 248.307 109.38 248.318 109.363L252.066 103.303C252.113 103.228 252.14 103.135 252.146 103.037C252.151 102.939 252.133 102.84 252.095 102.751L247.729 92.7599C247.691 92.6713 247.673 92.572 247.679 92.4741C247.684 92.3761 247.712 92.2837 247.759 92.2081L249.814 88.8853C249.825 88.8677 249.832 88.8475 249.836 88.8258C249.841 88.8042 249.841 88.7815 249.838 88.759C249.835 88.7366 249.829 88.7149 249.819 88.6951C249.81 88.6753 249.798 88.6579 249.783 88.6438Z",
    fill: "url(#paint61_linear_502_5693)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M252.113 91.1837L250.393 93.9643C250.363 94.0148 250.347 94.0755 250.344 94.1393C250.342 94.2032 250.354 94.2676 250.379 94.3251L253.267 100.964C253.278 100.989 253.293 101.011 253.312 101.027C253.331 101.044 253.353 101.054 253.375 101.057C253.398 101.061 253.42 101.057 253.44 101.047C253.461 101.036 253.479 101.019 253.492 100.998L256.716 95.7864C256.726 95.7692 256.734 95.7493 256.738 95.7278C256.742 95.7064 256.743 95.6839 256.741 95.6616C256.738 95.6393 256.732 95.6176 256.722 95.5979C256.713 95.5782 256.701 95.5609 256.686 95.5469L252.303 91.1638C252.289 91.1492 252.273 91.1381 252.255 91.1311C252.238 91.1242 252.22 91.1216 252.202 91.1234C252.185 91.1253 252.168 91.1316 252.152 91.1419C252.137 91.1523 252.124 91.1665 252.113 91.1837Z",
    fill: "url(#paint62_linear_502_5693)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M241.415 102.46L243.135 99.679C243.164 99.6283 243.18 99.5677 243.183 99.5039C243.185 99.4402 243.174 99.3758 243.149 99.3182L240.256 92.6866C240.245 92.6616 240.229 92.6402 240.21 92.6243C240.191 92.6084 240.169 92.5984 240.147 92.5953C240.124 92.5922 240.102 92.596 240.081 92.6064C240.061 92.6167 240.043 92.6334 240.03 92.6549L236.812 97.8569C236.801 97.8739 236.793 97.8936 236.788 97.9149C236.784 97.9362 236.783 97.9587 236.785 97.981C236.788 98.0034 236.793 98.0251 236.803 98.045C236.812 98.0649 236.824 98.0825 236.838 98.0968L241.223 102.482C241.252 102.511 241.289 102.525 241.325 102.521C241.361 102.517 241.393 102.495 241.415 102.46Z",
    fill: "url(#paint63_linear_502_5693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_5693",
    x1: 158.632,
    y1: 52.6878,
    x2: 195.992,
    y2: 88.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_5693",
    x1: 158.353,
    y1: 52.9793,
    x2: 195.713,
    y2: 88.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_5693",
    x1: 158.218,
    y1: 53.1216,
    x2: 195.575,
    y2: 88.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_5693",
    x1: 157.94,
    y1: 53.4132,
    x2: 195.3,
    y2: 89.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_5693",
    x1: 157.665,
    y1: 53.7013,
    x2: 195.022,
    y2: 89.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_5693",
    x1: 157.387,
    y1: 53.9928,
    x2: 194.748,
    y2: 89.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_5693",
    x1: 157.112,
    y1: 54.2809,
    x2: 194.473,
    y2: 89.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_502_5693",
    x1: 156.834,
    y1: 54.5691,
    x2: 194.195,
    y2: 90.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_502_5693",
    x1: 156.56,
    y1: 54.8607,
    x2: 193.92,
    y2: 90.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_502_5693",
    x1: 156.286,
    y1: 55.1488,
    x2: 193.643,
    y2: 90.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_502_5693",
    x1: 156.007,
    y1: 55.437,
    x2: 193.368,
    y2: 91.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_502_5693",
    x1: 180.673,
    y1: 52.1945,
    x2: 175.092,
    y2: 85.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_502_5693",
    x1: 203.887,
    y1: 43.2909,
    x2: 157.13,
    y2: 89.7125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_502_5693",
    x1: 170.361,
    y1: 69.203,
    x2: 185.02,
    y2: 69.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_502_5693",
    x1: 170.361,
    y1: 69.203,
    x2: 185.02,
    y2: 69.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_502_5693",
    x1: 170.361,
    y1: 69.203,
    x2: 185.02,
    y2: 69.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_502_5693",
    x1: 104.693,
    y1: 28.9859,
    x2: 174.821,
    y2: -15.1306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_502_5693",
    x1: 105.035,
    y1: 29.5283,
    x2: 175.163,
    y2: -14.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_502_5693",
    x1: 105.206,
    y1: 29.7995,
    x2: 175.333,
    y2: -14.3136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_502_5693",
    x1: 105.548,
    y1: 30.3453,
    x2: 175.675,
    y2: -13.7712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_502_5693",
    x1: 105.89,
    y1: 30.8877,
    x2: 176.018,
    y2: -13.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_502_5693",
    x1: 106.232,
    y1: 31.4301,
    x2: 176.356,
    y2: -12.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_502_5693",
    x1: 106.571,
    y1: 31.9724,
    x2: 176.699,
    y2: -12.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_502_5693",
    x1: 106.914,
    y1: 32.5181,
    x2: 177.041,
    y2: -11.5983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_502_5693",
    x1: 107.256,
    y1: 33.0606,
    x2: 177.383,
    y2: -11.0559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_502_5693",
    x1: 107.599,
    y1: 33.603,
    x2: 177.726,
    y2: -10.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_502_5693",
    x1: 107.941,
    y1: 34.1454,
    x2: 178.065,
    y2: -9.97109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_502_5693",
    x1: 129.256,
    y1: -32.748,
    x2: 142.399,
    y2: 22.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_502_5693",
    x1: 107.856,
    y1: -45.1111,
    x2: 161.702,
    y2: 45.8677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_502_5693",
    x1: 124.998,
    y1: 6.71401,
    x2: 152.991,
    y2: 6.71401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_502_5693",
    x1: 124.998,
    y1: 6.71401,
    x2: 152.991,
    y2: 6.71401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_502_5693",
    x1: 124.998,
    y1: 6.71401,
    x2: 152.991,
    y2: 6.71401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_502_5693",
    x1: -3.15585,
    y1: 18.8322,
    x2: 90.3349,
    y2: 77.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_502_5693",
    x1: -3.60813,
    y1: 19.5576,
    x2: 89.8792,
    y2: 78.0846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_502_5693",
    x1: -3.83538,
    y1: 19.9204,
    x2: 89.6519,
    y2: 78.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_502_5693",
    x1: -4.28911,
    y1: 20.6425,
    x2: 89.2016,
    y2: 79.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_502_5693",
    x1: -4.74438,
    y1: 21.3678,
    x2: 88.7463,
    y2: 79.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_502_5693",
    x1: -5.19374,
    y1: 22.0899,
    x2: 88.2936,
    y2: 80.6203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_502_5693",
    x1: -5.64901,
    y1: 22.8153,
    x2: 87.8383,
    y2: 81.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_502_5693",
    x1: -6.10274,
    y1: 23.5407,
    x2: 87.388,
    y2: 82.0678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_502_5693",
    x1: -6.55744,
    y1: 24.2628,
    x2: 86.9333,
    y2: 82.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_502_5693",
    x1: -7.00737,
    y1: 24.9883,
    x2: 86.4799,
    y2: 83.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_502_5693",
    x1: -7.46164,
    y1: 25.7138,
    x2: 86.0257,
    y2: 84.2408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_502_5693",
    x1: 85.0754,
    y1: 12.5371,
    x2: 26.0467,
    y2: 60.4774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_502_5693",
    x1: -3.53896,
    y1: 46.7144,
    x2: 89.5246,
    y2: 46.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_502_5693",
    x1: 24.1313,
    y1: 47.3622,
    x2: 63.9842,
    y2: 47.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_502_5693",
    x1: 24.1313,
    y1: 47.3622,
    x2: 63.9842,
    y2: 47.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_502_5693",
    x1: 24.1313,
    y1: 47.3622,
    x2: 63.9842,
    y2: 47.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_502_5693",
    x1: 232.004,
    y1: 127.044,
    x2: 264.012,
    y2: 63.6824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_502_5693",
    x1: 232.496,
    y1: 127.291,
    x2: 264.503,
    y2: 63.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_502_5693",
    x1: 232.74,
    y1: 127.413,
    x2: 264.748,
    y2: 64.0553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_502_5693",
    x1: 233.231,
    y1: 127.664,
    x2: 265.239,
    y2: 64.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_502_5693",
    x1: 233.718,
    y1: 127.911,
    x2: 265.729,
    y2: 64.5503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_502_5693",
    x1: 234.211,
    y1: 128.159,
    x2: 266.222,
    y2: 64.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_502_5693",
    x1: 234.702,
    y1: 128.406,
    x2: 266.71,
    y2: 65.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_502_5693",
    x1: 235.194,
    y1: 128.654,
    x2: 267.202,
    y2: 65.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_502_5693",
    x1: 235.685,
    y1: 128.901,
    x2: 267.693,
    y2: 65.5435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_502_5693",
    x1: 236.173,
    y1: 129.149,
    x2: 268.185,
    y2: 65.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_502_5693",
    x1: 236.666,
    y1: 129.4,
    x2: 268.677,
    y2: 66.0385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_502_5693",
    x1: 226.197,
    y1: 95.8258,
    x2: 268.121,
    y2: 95.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_502_5693",
    x1: 201.607,
    y1: 71.242,
    x2: 281.314,
    y2: 114.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_502_5693",
    x1: 241.012,
    y1: 91.0723,
    x2: 254.476,
    y2: 99.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_502_5693",
    x1: 241.012,
    y1: 91.0723,
    x2: 254.476,
    y2: 99.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_502_5693",
    x1: 241.012,
    y1: 91.0723,
    x2: 254.476,
    y2: 99.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCoin);
export default __webpack_public_path__ + "static/media/bannerCoin.6ae2e763.svg";
export { ForwardRef as ReactComponent };